export const BRAND = {
  name: "SLALY",
  full: "SLALY HAIR & BEAUTY TECH",
  phoneDisplay: "07467 591554",
  tel: "+447467591554",
  whatsapp: "447467591554",
  email: "slalybeautician@gmail.com",
  owner: "Essi Delali Miawotoe",
  address: "13 Rose Parade, High St, Wallington SM6 8QG",
  mapsQuery: "13 Rose Parade, High St, Wallington SM6 8QG",
  instagram: "https://www.instagram.com/hairandbeauty_by_slaly/",
  facebook: "https://www.facebook.com/share/18ys7eutfh/",
  tiktok: "https://www.tiktok.com/@slaly410?_r=1&_t=ZN-98NMTAZyHQs",
  googleReview: "https://maps.app.goo.gl/WqaXYvCxFC1vkjp67?g_st=am",
  logo: "https://customer-assets-7cd3h4nn.emergentagent.net/job_slaly-salon/artifacts/dnw10m1p_Screenshot%202026-07-27%20091036.png",
  crown: "https://static.prod-images.emergentagent.com/jobs/8516d3e4-b5c8-4c39-bc66-dd025d1b124a/images/b2e34ea0918a6dd8c28812546782059c56d706b7d5b708e960c0b250b324c5f7.jpeg",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1673470907547-1c0c6a996095?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  manifesto: "https://images.unsplash.com/photo-1633681926035-ec1ac984418a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  founder: "https://customer-assets-7cd3h4nn.emergentagent.net/job_slaly-salon/artifacts/hrhwmgli_IMG-20260727-WA0007.jpg",
  african: "https://images.unsplash.com/photo-1594254773847-9fce26e950bc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  european: "https://images.unsplash.com/photo-1568038479111-87bf80659645?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  studio: {
    storefront: "https://customer-assets-7cd3h4nn.emergentagent.net/job_slaly-salon/artifacts/zuytysbn_IMG-20260301-WA0007.jpg",
    interior: "https://customer-assets-7cd3h4nn.emergentagent.net/job_slaly-salon/artifacts/vfjrto86_IMG-20260301-WA0012.jpg",
    street: "https://customer-assets-7cd3h4nn.emergentagent.net/job_slaly-salon/artifacts/8pq5qffy_IMG-20260301-WA0006.jpg",
    award: "https://customer-assets-7cd3h4nn.emergentagent.net/job_slaly-salon/artifacts/s41prc1v_IMG-20260301-WA0009.jpg",
  },
  gallery: [
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_slaly-salon/artifacts/bj9nxxqk_IMG-20260724-WA0015.jpg",
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_slaly-salon/artifacts/h2ctflwf_IMG-20260724-WA0021.jpg",
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_slaly-salon/artifacts/qs04uczg_IMG-20260724-WA0016.jpg",
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_slaly-salon/artifacts/1ueqkf93_IMG-20260724-WA0019.jpg",
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_slaly-salon/artifacts/xihossel_IMG-20260724-WA0014.jpg",
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_slaly-salon/artifacts/y2yetk35_IMG-20260724-WA0023.jpg",
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_slaly-salon/artifacts/6ixv347w_IMG-20260724-WA0018.jpg",
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_slaly-salon/artifacts/1ol35gun_IMG-20260724-WA0020.jpg",
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_slaly-salon/artifacts/9ytde6fh_IMG-20260724-WA0022.jpg",
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_slaly-salon/artifacts/advq3loa_IMG-20260724-WA0017.jpg",
  ],
};

export const SERVICES = {
  african: [
    { en: "Single Plaits", fr: "Nattes Individuelles", price: 85 },
    { en: "Kinky Twist", fr: "Twist Crépus", price: 75 },
    { en: "Weave", fr: "Tissage", price: 60 },
    { en: "Tracks", fr: "Extensions à Coudre", price: 50 },
    { en: "Cornrows", fr: "Tresses Collées", price: 25 },
    { en: "Gel Twist", fr: "Twist au Gel", price: 30 },
    { en: "Pony Tails", fr: "Queues de Cheval", price: 30 },
    { en: "Curly Perm", fr: "Permanente Bouclée", price: 65 },
    { en: "Relaxer", fr: "Défrisage", price: 40 },
  ],
  european: [
    { en: "Wash & Blow Dry", fr: "Shampoing & Brushing", price: 25 },
    { en: "Women's Haircut", fr: "Coupe Femme", price: 20 },
    { en: "Hair Trim", fr: "Pointes / Rafraîchissement", price: 10 },
    { en: "Tong / Curls", fr: "Boucles au Fer", price: 15 },
    { en: "Wash & Tong", fr: "Shampoing & Boucles", price: 35 },
    { en: "Brazilian Blow Dry", fr: "Brushing Brésilien", price: 85 },
    { en: "Brazilian Keratin", fr: "Kératine Brésilienne", price: 150 },
    { en: "Hair Extensions", fr: "Extensions Capillaires", price: 220 },
    { en: "Colour / Dye", fr: "Coloration", price: 30 },
  ],
  treatments: [
    { en: "Mimetise Treatment", fr: "Soin Mimetise", price: 45 },
    { en: "Scalp Treatment", fr: "Soin du Cuir Chevelu", price: 40 },
    { en: "Grow Hair Treatment", fr: "Soin Pousse", price: 40 },
    { en: "Hydrate Treatment", fr: "Soin Hydratant", price: 35 },
  ],
};

export const HOURS = [
  { day: { en: "Monday", fr: "Lundi" }, time: { en: "By Appointment", fr: "Sur Rendez-vous" }, appt: true },
  { day: { en: "Tuesday", fr: "Mardi" }, time: { en: "10:00 – 18:30", fr: "10:00 – 18:30" } },
  { day: { en: "Wednesday", fr: "Mercredi" }, time: { en: "10:00 – 18:30", fr: "10:00 – 18:30" } },
  { day: { en: "Thursday", fr: "Jeudi" }, time: { en: "10:00 – 18:30", fr: "10:00 – 18:30" } },
  { day: { en: "Friday", fr: "Vendredi" }, time: { en: "10:00 – 18:30", fr: "10:00 – 18:30" } },
  { day: { en: "Saturday", fr: "Samedi" }, time: { en: "09:30 – 17:00", fr: "09:30 – 17:00" } },
  { day: { en: "Sunday", fr: "Dimanche" }, time: { en: "By Appointment", fr: "Sur Rendez-vous" }, appt: true },
];

export const T = {
  awards: {
    years: { en: "Celebrating 8 Years", fr: "8 Ans d'Excellence" },
    nominee: { en: "2026 Nominee", fr: "Nominé 2026" },
    title: {
      en: "Nominated · Best Beauty Salon",
      fr: "Nominé · Meilleur Salon de Beauté",
    },
    sub: {
      en: "London Retail Business Awards 2026 — England's Business Awards Show finalist.",
      fr: "London Retail Business Awards 2026 — finaliste de l'England's Business Awards Show.",
    },
    rating: { en: "5.0 on Google", fr: "5,0 sur Google" },
  },
  studio: {
    label: { en: "The Studio", fr: "Le Studio" },
    title: { en: "Our home in Wallington", fr: "Notre écrin à Wallington" },
    body: {
      en: "Step inside our salon on Rose Parade — a warm, welcoming space kitted with professional tools and premium products for every hair type.",
      fr: "Poussez la porte de notre salon sur Rose Parade — un espace chaleureux, équipé d'outils professionnels et de produits premium pour tous types de cheveux.",
    },
    cap_storefront: { en: "Our shopfront", fr: "Notre devanture" },
    cap_interior: { en: "Styling station", fr: "Poste de coiffure" },
    cap_street: { en: "High St, Wallington", fr: "High St, Wallington" },
  },
  nav: {
    about: { en: "Story", fr: "Histoire" },
    services: { en: "Services", fr: "Services" },
    gallery: { en: "Gallery", fr: "Galerie" },
    visit: { en: "Visit", fr: "Nous Trouver" },
    book: { en: "Book Now", fr: "Réserver" },
    call: { en: "Call", fr: "Appeler" },
    shop: { en: "Shop", fr: "Boutique" },
    reviews: { en: "Reviews", fr: "Avis" },
  },
  reviews: {
    label: { en: "Client Love", fr: "Avis Clients" },
    title: { en: "Kind words", fr: "Elles témoignent" },
    intro: { en: "Real reviews from the Slaly family.", fr: "De vrais avis de la famille Slaly." },
    seeAll: { en: "Read all reviews", fr: "Voir tous les avis" },
    leave: { en: "Leave a review", fr: "Laisser un avis" },
    formTitle: { en: "Share your experience", fr: "Partagez votre expérience" },
    formSub: { en: "Your review will appear once approved by Essi.", fr: "Votre avis apparaîtra après validation par Essi." },
    name: { en: "Your name", fr: "Votre nom" },
    rating: { en: "Your rating", fr: "Votre note" },
    message: { en: "Your review", fr: "Votre avis" },
    submit: { en: "Submit review", fr: "Envoyer l'avis" },
    success: { en: "Thank you! Your review is awaiting approval.", fr: "Merci ! Votre avis est en attente de validation." },
    empty: { en: "No reviews yet — be the first!", fr: "Aucun avis pour l'instant — soyez la première !" },
    back: { en: "Back to site", fr: "Retour au site" },
    google: { en: "Review us on Google", fr: "Nous noter sur Google" },
    photo: { en: "Add a photo (optional)", fr: "Ajouter une photo (optionnel)" },
    count: { en: "reviews", fr: "avis" },
    replyLabel: { en: "Slaly's reply", fr: "Réponse de Slaly" },
    replyPlaceholder: { en: "Write a public reply…", fr: "Rédiger une réponse publique…" },
    reply: { en: "Reply", fr: "Répondre" },
    verified: { en: "Verified Results", fr: "Résultats Vérifiés" },
    verifiedSub: { en: "Real photos shared by our clients.", fr: "De vraies photos partagées par nos clientes." },
  },
  qr: {
    title: { en: "Scan to book", fr: "Scannez pour réserver" },
    sub: { en: "Point your camera — chat with us on WhatsApp instantly.", fr: "Pointez votre caméra — discutez avec nous sur WhatsApp instantanément." },
  },
  products: {
    label: { en: "The Shop", fr: "La Boutique" },
    title: { en: "Hair Products", fr: "Produits Capillaires" },
    intro: { en: "Salon-quality products, hand-picked by Essi. Order via WhatsApp for collection or delivery.", fr: "Des produits de qualité salon, sélectionnés par Essi. Commandez sur WhatsApp pour retrait ou livraison." },
    order: { en: "Order on WhatsApp", fr: "Commander sur WhatsApp" },
    back: { en: "Back to site", fr: "Retour au site" },
    empty: { en: "Products coming soon.", fr: "Produits bientôt disponibles." },
    msg: { en: "Hello Slaly, I'd like to order:", fr: "Bonjour Slaly, je souhaite commander :" },
  },
  hero: {
    eyebrow: { en: "Wallington · London", fr: "Wallington · Londres" },
    lines: {
      en: ["The Art of", "Hair,", "Crowned."],
      fr: ["L'Art du", "Cheveu,", "Couronné."],
    },
    sub: {
      en: "African braids, natural textures & European luxury care — crafted with precision in the heart of Wallington.",
      fr: "Tresses africaines, textures naturelles & soins de luxe européens — façonnés avec précision au cœur de Wallington.",
    },
    scroll: { en: "Scroll", fr: "Défiler" },
  },
  marquee: {
    en: ["Regal", "Luxurious", "Expert Care", "Braids", "Keratin", "Extensions", "Colour", "Natural Hair"],
    fr: ["Royal", "Luxueux", "Soin Expert", "Tresses", "Kératine", "Extensions", "Coloration", "Cheveux Naturels"],
  },
  manifesto: {
    label: { en: "The House of Slaly", fr: "La Maison Slaly" },
    title: {
      en: "Two worlds of hair, one crown of excellence.",
      fr: "Deux univers capillaires, une seule couronne d'excellence.",
    },
    chapters: [
      {
        num: "01",
        title: { en: "Heritage", fr: "Héritage" },
        body: {
          en: "From single plaits to intricate cornrows, our braiding honours tradition and celebrates natural texture with patient, protective artistry.",
          fr: "Des nattes individuelles aux tresses collées les plus fines, notre travail honore la tradition et célèbre la texture naturelle avec un art protecteur et minutieux.",
        },
      },
      {
        num: "02",
        title: { en: "Precision", fr: "Précision" },
        body: {
          en: "European cuts, Brazilian keratin, colour and extensions — refined techniques delivered with a couture eye for detail and finish.",
          fr: "Coupes européennes, kératine brésilienne, coloration et extensions — des techniques raffinées livrées avec un œil couture pour le détail et la finition.",
        },
      },
      {
        num: "03",
        title: { en: "Care", fr: "Soin" },
        body: {
          en: "Scalp, hydration and growth treatments designed to nurture hair back to strength — because true luxury is healthy hair.",
          fr: "Soins du cuir chevelu, d'hydratation et de pousse conçus pour redonner force au cheveu — car le vrai luxe, c'est une chevelure saine.",
        },
      },
    ],
  },
  services: {
    label: { en: "Menu & Pricing", fr: "Carte & Tarifs" },
    title: { en: "Services", fr: "Prestations" },
    note: {
      en: "Prices shown are starting from. Final price varies with hair length, style and requirements.",
      fr: "Les prix indiqués sont à partir de. Le tarif final varie selon la longueur, le style et les besoins.",
    },
    from: { en: "from", fr: "dès" },
    cat_african: { en: "African Braids & Natural Hair", fr: "Tresses Africaines & Cheveux Naturels" },
    cat_european: { en: "European Styles & Luxury Care", fr: "Styles Européens & Soins de Luxe" },
    cat_treatments: { en: "Treatments", fr: "Soins" },
  },
  gallery: {
    label: { en: "The Gallery", fr: "La Galerie" },
    title: { en: "Crafted Crowns", fr: "Couronnes Façonnées" },
  },
  visit: {
    label: { en: "Visit Us", fr: "Nous Rendre Visite" },
    title: { en: "Find your seat.", fr: "Trouvez votre fauteuil." },
    hours: { en: "Opening Hours", fr: "Horaires d'Ouverture" },
    location: { en: "Location", fr: "Adresse" },
    directions: { en: "Get Directions", fr: "Itinéraire" },
  },
  cta: {
    title: { en: "Ready for your transformation?", fr: "Prête pour votre transformation ?" },
    sub: {
      en: "Book by phone or WhatsApp. Walk-ins welcome during opening hours.",
      fr: "Réservez par téléphone ou WhatsApp. Sans rendez-vous pendant les horaires d'ouverture.",
    },
  },
  footer: {
    tagline: { en: "Hair & Beauty, crowned in Wallington.", fr: "Coiffure & Beauté, couronnées à Wallington." },
    rights: { en: "All rights reserved.", fr: "Tous droits réservés." },
  },
};
